import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronUp } from 'react-icons/fa';
import { Container, Typography } from 'amphitheatre';

import { Content, ReturnButton } from '../Tutorials.styled';

const { Header } = Typography;

interface Props {
  children?: React.ReactNode;
  nobg?: boolean;
  title: string;
}

const TutorialPage: React.FunctionComponent<Props> = ({
  children,
  nobg,
  title,
}: Props) => {
  function goTop() {
    window.scrollTo(0, 0);
  }

  useLayoutEffect(() => {
    goTop();
  }, []);

  return (
    <Container
      className={nobg ? 'anim-container' : 'content-container anim-container'}
      size="lg"
    >
      <Link to="/tutorials">
        <ReturnButton>
          <div className="icon">
            <FaChevronLeft />
          </div>
          Back
        </ReturnButton>
      </Link>
      <Header>{title}</Header>
      <Content>{children}</Content>
      <ReturnButton onClick={goTop} style={{ marginTop: '1rem' }}>
        <div className="icon">
          <FaChevronUp />
        </div>
        Go to top
      </ReturnButton>
    </Container>
  );
};

export default TutorialPage;
